import { Injectable } from '@angular/core';
import { TABLE_DEFINERS } from './pagination.constants';

@Injectable({
	providedIn: 'root'
})
export class PaginationService {
	private static readonly COOKIE_KEY = 'tablePagination';
	private defaultSize = 10;
	// Holds all table pagination info, keyed by table id
	private tablePagination: { [tableId: string]: { pageSize: number | 'ALL', pageIndex: number } } = {};
	private pagination: number[] = [10, 25, 50, -1];

	constructor() {
		this.loadFromCookies();
	}


	public getPersonalPagination(allOptionValue: number) 
	{
		// Return the pagination but replace the -1 value with the input value, the actuall ALL value.
		return this.pagination.map(opt => opt === -1 ? allOptionValue : opt);
	}


	public getCurrentPageSize(tableUniferId: number, currentMaxSize: number, callingClass: string): number 
	{
		if (currentMaxSize === 0) return 0;
		const tableId = this.getRequestingId(callingClass, tableUniferId);
		if (!tableId) 
		{
			return this.defaultSize;
		}
		const val = this.getPageSize(tableId);
		return val === -1 ? currentMaxSize : val;
	}

	// Handler for rows per page change, updates the page size in cookies using the dynamic table id
	onRowsPerPageChange(event: any, tableUniferId: number, allOptionValue: number, callingClass: string) {
		// Accepts either a number or an event object with .value
		const options = this.getPersonalPagination(allOptionValue);
    	const selectedIndex = options.findIndex(opt => opt === event.rows);
		const tableId = this.getRequestingId(callingClass, tableUniferId);
		this.setPageSize(tableId, selectedIndex);
	}


	private loadFromCookies() {
		const cookie = document.cookie.split('; ').find(row => row.startsWith(PaginationService.COOKIE_KEY + '='));
		if (cookie) {
			try {
				this.tablePagination = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
			}
			catch {
				this.tablePagination = {};
			}
		}
	}

	private saveToCookies() {
		document.cookie = `${PaginationService.COOKIE_KEY}=${encodeURIComponent(JSON.stringify(this.tablePagination))};path=/;max-age=31536000`;
	}

	setPageSize(tableId: string, index: number) {
		let size = this.pagination[index];
		if (!this.tablePagination[tableId]) {
			this.tablePagination[tableId] = { pageSize: size, pageIndex: 0 };
		} else {
			this.tablePagination[tableId].pageSize = size;
		}
		this.saveToCookies();
	}

	getPageSize(tableId: string): number {
		const val = this.tablePagination[tableId]?.pageSize;
		if (val === 'ALL') return -1;
		return val ?? this.defaultSize;
	}

	setPageIndex(tableId: string, pageIndex: number) {
		if (!this.tablePagination[tableId]) {
			this.tablePagination[tableId] = { pageSize: this.defaultSize, pageIndex };
		} else {
			this.tablePagination[tableId].pageIndex = pageIndex;
		}
		this.saveToCookies();
	}

	getPageIndex(tableId: string): number {
		return this.tablePagination[tableId]?.pageIndex ?? 0;
	}

	getRequestingId(requestingClass: string, subrequestNumber: number): string {
		return TABLE_DEFINERS.find(d => d.requestingClass === requestingClass)?.definedTables[subrequestNumber]!;
	}
}